"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _formMixin = _interopRequireDefault(require("../../formMixin"));
var _enum = require("../../../components/js/enum");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SearchForm',
  mixins: [_formMixin.default],
  data: function data() {
    return {
      placeholderPositionEnum: _enum.placeholderPositionEnum,
      form: {
        showType: 3,
        searchType: 1,
        searchPadding: {
          pt: 14,
          pb: 14,
          pl: 15,
          pr: 15
        }
      }
    };
  },
  watch: {
    propsData: {
      handler: function handler(propsData) {
        var _this$form;
        this.form = Object.assign(this.form, propsData);
        if (!((_this$form = this.form) !== null && _this$form !== void 0 && _this$form.searchPadding)) {
          this.$set(this.form, 'searchPadding', {
            pt: 14,
            pb: 14,
            pl: 15,
            pr: 15
          });
        }
        ;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    uploadbgImg: function uploadbgImg(prop) {
      var _this = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _this.$set(_this.form, prop, data[0].sattDir);
      });
    }
  }
};